import { create } from 'zustand'
import type { WalletBalance } from '@/data/MOCK-wallet-balance'
import { MOCK_WALLET_BALANCE } from '@/data/MOCK-wallet-balance'
import type { AuthState, AuthStatus, AuthUser, LoginStep } from '@/stores/types'

export const useAuthStore = create<AuthState>()((set) => {
	// Helper to check for localStorage availability
	const hasLocalStorage = typeof window !== 'undefined' && window.localStorage

	return {
		auth: {
			user: {
				balance: MOCK_WALLET_BALANCE, // Initialize with mock balance
			} as AuthUser,
			status: 'pending',
			loginStep: 'initial',
			accessToken: hasLocalStorage ? localStorage.getItem('accessToken') : null,
			refreshToken: hasLocalStorage ? localStorage.getItem('refreshToken') : null,
			setStatus: (status: AuthStatus) =>
				set((state) => ({
					...state,
					auth: {
						...state.auth,
						status,
					},
				})),
			setLoginStep: (loginStep: LoginStep) =>
				set((state) => ({
					...state,
					auth: {
						...state.auth,
						loginStep,
					},
				})),
			updateUser: (userUpdate) =>
				set((state) => ({
					...state,
					auth: {
						...state.auth,
						user: {
							...state.auth.user,
							...userUpdate,
						},
					},
				})),
			updateBalance: (balance: WalletBalance) =>
				set((state) => ({
					...state,
					auth: {
						...state.auth,
						user: {
							...state.auth.user,
							balance,
						},
					},
				})),
			setTokens: ({ accessToken, refreshToken }) => {
				if (hasLocalStorage) {
					localStorage.setItem('accessToken', accessToken)
					localStorage.setItem('refreshToken', refreshToken)
				}
				set((state) => ({
					...state,
					auth: {
						...state.auth,
						accessToken,
						refreshToken,
					},
				}))
			},
			clearAuth: () => {
				if (hasLocalStorage) {
					localStorage.removeItem('accessToken')
					localStorage.removeItem('refreshToken')
				}
				set((state) => ({
					...state,
					auth: {
						...state.auth,
						user: {
							balance: MOCK_WALLET_BALANCE,
						} as AuthUser,
						status: 'unauthenticated',
						loginStep: 'initial',
						accessToken: null,
						refreshToken: null,
					},
				}))
			},
		},
	}
})
